import Repository from './Repository';
const resource = '/content/feature/article';

export default {
  get() {
    return Repository.get(`${resource}`);
  }
};
